// extracted by mini-css-extract-plugin
module.exports = {"bellIcon":"IconComponent-IconComponent-bellIcon-589cbf34"};